export default "__VITE_ASSET__1a5316e5__"